import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import ClearIcon from "@material-ui/icons/Clear";
import Fab from '@material-ui/core/Fab';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormLabel from '@material-ui/core/FormLabel';
import Grid from '@material-ui/core/Grid'
import Modal from '@material-ui/core/Modal';
import PropTypes from 'prop-types';
import RadioButton from '@material-ui/core/Radio';
import RadioButtonGroup from '@material-ui/core/RadioGroup';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { connect } from "react-redux";
import { compose } from "redux";
import { teamRegistration } from "../actions/SessionAction";
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import { Sentry } from 'react-activity';
import 'react-activity/dist/react-activity.css';
// import IconButton from '@material-ui/core/IconButton';
// import PhotoCamera from '@material-ui/icons/PhotoCamera';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';

function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
        // borderBottom: '5px solid black',
    };
}

const { innerWidth } = window;

const styles = theme => ({
    paper: {
        position: 'absolute',
        // width: theme.spacing.unit * 100,
        width: innerWidth >= 480 ? theme.spacing.unit * 100 : (innerWidth - (theme.spacing.unit * 2)),
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: innerWidth >= 480 ? theme.spacing.unit * 4 : theme.spacing.unit * 2,
        // padding: '10px 32px 10px 32px',
        outline: 'none',
        borderRadius: 5
    },
    stepperClass: {
        padding: innerWidth >= 480 ? theme.spacing.unit * 2 : 0,
    },
    margin: {
        margin: theme.spacing.unit,
    },
    closeButtonFab: {
        float: 'right',
        marginRight: innerWidth >= 480 ? '-54px' : '-34px',
        marginTop: innerWidth >= 480 ? '-54px' : '-44px'
    },
    gradientButton: {
        background: '#2cc676',
        '&:focus': {
            background: '#27ad67'
        },
        '&:hover': {
            background: '#27ad67'
        },
        '&:active': {
            background: '#27ad67'
        }
    },
    backGrd: {
        background: 'linear-gradient(to right, #2926ac 0%, #6128be 100%)',
        height: 20
    },
    cancelbutton: {
        margin: theme.spacing.unit,
    },
    button: {
        background: 'linear-gradient(to right, #2926ac 0%, #6128be 100%)',
        color: 'white'
    },
    textField: {
        // width: 350,
        // marginTop: -1,
        // marginLeft: 8
        margin: 0
    },
    textField1: {
        width: 720,
        marginTop: -1,
        marginLeft: 8
    },
    textField2: {
        //    marginTop: -1,
        marginLeft: 8
    },
    input: {
        display: "none"
    },
    inputStyle: {
        padding: '12px 1px',
        fontSize: 12,
        color: 'rgba(0, 0, 0, 0.87)',
    },
    inputStyle1: {
        padding: '12px 1px',
        fontSize: 12,
        color: 'rgba(0, 0, 0, 0.87)',
        textTransform: "capitalize"
    },
    labelRoot: {
        fontSize: '1.3rem'
    },
    button1: {
        marginRight: theme.spacing.unit,
    },
    instructions: {
        marginTop: theme.spacing.unit,
        marginBottom: theme.spacing.unit,
    },
    steblabel: {
        fontSize: 50,
        fontWeight: "Bold"
    }
});

function getSteps() {
    return ['Team Register', 'Coach Register', 'Completed'];
}


class TeamRegistration extends Component {
    state = {
        open: false,
        interested_in_stem: null,
        team_name: '',
        website_url: '',
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        confirm_password: '',
        first_name_error: false,
        last_name_error: false,
        email_error: false,
        invalid_email_error: false,
        password_error: false,
        invalid_password_error: false,
        confirm_password_error: false,
        invalid_confirm_password_error: false,
        interested_in_stem_error: false,
        team_name_error: false,
        website_url_error: false,
        website_url_invalid_error: false,
        activeStep: 0,
        displayCloseButton: true,
        activityIndicatorProcess: true,
        registerError: "",
        user_type: "COACH",
        description: "",
        city: "",
        team_image: null,
        coach_image: null,
        selected_team_image_name: "",
        selected_coach_image_name: ""
    };



    handleBack = () => {
        this.setState(state => ({
            activeStep: state.activeStep - 1,
        }));
    };

    handleOpen = () => {
        this.setState({ open: true });
    };

    handleClose = () => {
        this.setState({
            open: false,
            interested_in_stem: null,
            team_name: '',
            website_url: '',
            first_name: '',
            last_name: '',
            email: '',
            password: '',
            confirm_password: '',
            first_name_error: false,
            last_name_error: false,
            email_error: false,
            invalid_email_error: false,
            password_error: false,
            invalid_password_error: false,
            confirm_password_error: false,
            invalid_confirm_password_error: false,
            interested_in_stem_error: false,
            team_name_error: false,
            website_url_error: false,
            website_url_invalid_error: false,
            activeStep: 0,
            description: "",
            city: "",
            team_image: null,
            coach_image: null,
            selected_team_image_name: "",
            selected_coach_image_name: ""
        });

    };
    handleChangeApproval = (event) => {
        this.setState({ interested_in_stem: event.target.value, interested_in_stem_error: false })
    };

    validateEmail(email) {
        var re = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    validateUrl(url) {
        var re = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\\-\\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/
        return re.test(url);
    }

    handleNext = () => {
        const { activeStep } = this.state;
        let isError = false;
        if (this.state.interested_in_stem === null) {
            this.setState({ interested_in_stem_error: true })
            isError = true
        }

        if (this.state.team_name === "") {
            this.setState({ team_name_error: true })
            isError = true
        }
        if (this.state.website_url !== "") {
            if (!this.validateUrl(this.state.website_url)) {
                this.setState({ website_url_invalid_error: true })
                isError = true
            }
        }

        if (isError === false) {
            this.setState({
                activeStep: activeStep + 1,
            });
        }
    };
    teamImage = ({ target }) => {
        this.setState({ team_image: target.files[0], selected_team_image_name: target.files[0].name });
    };
    coachImage = ({ target }) => {
        this.setState({ coach_image: target.files[0], selected_coach_image_name: target.files[0].name });
    };

    submitform = () => {
        let isError = false;
        if (this.state.first_name === "") {
            this.setState({ first_name_error: true })
            isError = true
        }
        if (this.state.last_name === "") {
            this.setState({ last_name_error: true })
            isError = true
        }

        if (this.state.email !== null && this.state.email !== "") {
            if (!this.validateEmail(this.state.email) === true) {
                this.setState({ invalid_email_error: true })
                isError = true
            }
        } else {
            isError = true
            this.setState({ email_error: true })
        }

        if (this.state.password !== null && this.state.password !== "") {
            if (!(this.state.password.length >= 8)) {
                this.setState({ invalid_password_error: true })
                isError = true
            }
        } else {
            this.setState({ password_error: true })
            isError = true
        }

        if (this.state.confirm_password !== null && this.state.confirm_password !== "") {
            if (!(this.state.password === this.state.confirm_password)) {
                this.setState({ invalid_confirm_password_error: true })
                isError = true
            }
        } else {
            this.setState({ confirm_password_error: true })
            isError = true
        }

        if (isError === false) {
            this.props.dispatch(teamRegistration(this, this.state))
            if(this.state.statuses !== "success"){

            
                this.setState({
                    // interested_in_stem: null,
                    // team_name: '',
                    // website_url: '',
                    // first_name: '',
                    // last_name: '',
                    // email: '',
                    // password: '',
                    // confirm_password: '',
                    // first_name_error: false,
                    // last_name_error: false,
                    // email_error: false,
                    // invalid_email_error: false,
                    // password_error: false,
                    // invalid_password_error: false,
                    // confirm_password_error: false,
                    // invalid_confirm_password_error: false,
                    // interested_in_stem_error: false,
                    // team_name_error: false,
                    // website_url_error: false,
                    // website_url_invalid_error: false,
                    activeStep: this.state.activeStep + 1,
                    open: true,
                    // description: "",
                    // city: "",
                    // team_image: null,
                    // coach_image: null,
                    // selected_team_image_name: "",
                    // selected_coach_image_name: ""
                })
            }else{
                this.setState({
                    interested_in_stem: null,
                    team_name: '',
                    website_url: '',
                    first_name: '',
                    last_name: '',
                    email: '',
                    password: '',
                    confirm_password: '',
                    first_name_error: false,
                    last_name_error: false,
                    email_error: false,
                    invalid_email_error: false,
                    password_error: false,
                    invalid_password_error: false,
                    confirm_password_error: false,
                    invalid_confirm_password_error: false,
                    interested_in_stem_error: false,
                    team_name_error: false,
                    website_url_error: false,
                    website_url_invalid_error: false,
                    activeStep: this.state.activeStep + 1,
                    open: true,
                    description: "",
                    city: "",
                    team_image: null,
                    coach_image: null,
                    selected_team_image_name: "",
                    selected_coach_image_name: ""
                });
            }
            
        }

    }

    render() {
        const { classes } = this.props;
        const steps = getSteps();
        const { activeStep } = this.state;
        return (
            <div style={{ marginTop: 10 }}>
                <Button variant="contained" color="secondary" size="small" className={classes.gradientButton} onClick={this.handleOpen}>Register Team !</Button>
                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={this.state.open}
                    onClose={this.handleClose}
                    disableBackdropClick={true}
                >
                    <div style={getModalStyle()} className={classes.paper}>
                        {(this.state.displayCloseButton &&
                            <div className={classes.closeButtonFab}>
                                <Fab size="small" color="secondary" aria-label="Add" className={classes.margin} onClick={this.handleClose}>
                                    <ClearIcon />
                                </Fab>
                            </div>
                        )}
                        <Stepper activeStep={activeStep} className={classes.stepperClass}>
                            {steps.map((label, index) => {
                                const props = {};
                                return (
                                    <Step key={label} {...props} >
                                        <StepLabel><span style={{ fontSize: 14 }}>{label}</span></StepLabel>
                                    </Step>
                                );
                            })}
                        </Stepper>
                        <div>
                            {activeStep === steps.length - 1 ? (
                                this.state.activityIndicatorProcess ?
                                    <div style={{ textAlign: "center" }}>
                                        <Sentry style={{ textAlign: "center" }} color="green" size={90} speed={1} animating={this.state.activityIndicatorProcess} />
                                    </div>
                                    : (this.state.statuses === "success" ?
                                        <div>
                                            {/* <Typography variant="h4"  style={{color: "green",textAlign: "center"}}>Thank you for registering with thunderBots!</Typography> */}
                                            <center style={{ color: "green", fontSize: 20 }}>
                                                {"Thank you for registering with ThunderBots. You will receive notification as email after your application has been approved."}
                                            </center>
                                        </div>
                                        :
                                        <div> 
                                                                                
                                            <center style={{ color: "red", fontSize: 20 }}>
                                                                                           
                                                {/* {"Your registration is failed !"} */}
                                                {this.state.registerError}
                                            </center>
                                            <Grid item xs={12} >
                                            <div style={{ textAlign: "center",paddingTop: 50 }}>
                                            <Button
                                                disabled={activeStep === 1}
                                                onClick={this.handleBack}
                                                variant="contained" style={{backgroundColor:"blue",color:"white"}}size="small" className={classes.cancelbutton}                >
                                                Back
                                            </Button>  
                                            <Button variant="contained" color="secondary" size="small" className={classes.cancelbutton} onClick={this.handleClose}>
                                                cancel
                                            </Button>
                                               
                                            </div>
                                            </Grid>
                                        </div>)
                            ) : (
                                    <div>
                                        <div>
                                            {activeStep === steps.length - 2 ?
                                                <div>
                                                    <Grid container spacing={8}>
                                                        <Grid item xs={6} >
                                                            <TextField
                                                                label="First name"
                                                                fullWidth
                                                                className={classes.textField}
                                                                required
                                                                error={this.state.first_name_error === true ? true : false}
                                                                helperText={this.state.first_name_error === true ? "Please Enter First Name" : null}
                                                                value={this.state.first_name || ""}
                                                                onChange={(event) => this.setState({ first_name: event.target.value.charAt(0).toUpperCase() + event.target.value.slice(1), first_name_error: false })}
                                                                margin="normal"
                                                                InputProps={{ classes: { input: classes.inputStyle } }}
                                                                InputLabelProps={{
                                                                    shrink: true,
                                                                    FormLabelClasses: {
                                                                        root: classes.labelRoot
                                                                    }
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={6} >
                                                            <TextField
                                                                label="Last name"
                                                                fullWidth
                                                                className={classes.textField}
                                                                required
                                                                error={this.state.last_name_error === true ? true : false}
                                                                helperText={this.state.last_name_error === true ? "Please Enter Last Name" : null}
                                                                value={this.state.last_name || ""}
                                                                onChange={(event) => this.setState({ last_name: event.target.value.charAt(0).toUpperCase() + event.target.value.slice(1), last_name_error: false })}
                                                                margin="normal"
                                                                InputProps={{ classes: { input: classes.inputStyle } }}
                                                                InputLabelProps={{
                                                                    shrink: true,
                                                                    FormLabelClasses: {
                                                                        root: classes.labelRoot
                                                                    }
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} >
                                                            <TextField
                                                                label="Email"
                                                                type="email"
                                                                fullWidth
                                                                className={classes.textField}
                                                                required
                                                                error={this.state.email_error === true ? true : this.state.invalid_email_error === true ? true : false}
                                                                helperText={this.state.email_error === true ? "Please Enter email" : this.state.invalid_email_error === true ? "Please enter valid email" : null}
                                                                value={this.state.email || ""}
                                                                onChange={(event) => this.setState({ email: event.target.value, email_error: false, invalid_email_error: false })}
                                                                margin="normal"
                                                                InputProps={{ classes: { input: classes.inputStyle } }}
                                                                InputLabelProps={{
                                                                    shrink: true,
                                                                    FormLabelClasses: {
                                                                        root: classes.labelRoot
                                                                    }
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={6} >
                                                            <TextField
                                                                label="Password"
                                                                type="password"
                                                                fullWidth
                                                                className={classes.textField}
                                                                required
                                                                error={this.state.password_error === true ? true : this.state.invalid_password_error === true ? true : false}
                                                                helperText={this.state.password_error === true ? "Please Enter Password" : this.state.invalid_password_error === true ? "Password must be 8 character" : null}
                                                                value={this.state.password || ""}
                                                                onChange={(event) => this.setState({ password: event.target.value, password_error: false, invalid_password_error: false })}
                                                                margin="normal"
                                                                InputProps={{ classes: { input: classes.inputStyle } }}
                                                                InputLabelProps={{
                                                                    shrink: true,
                                                                    FormLabelClasses: {
                                                                        root: classes.labelRoot
                                                                    }
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={6} >
                                                            <TextField
                                                                label="Confirm Password"
                                                                type="password"
                                                                fullWidth
                                                                className={classes.textField}
                                                                required
                                                                error={this.state.confirm_password_error === true ? true : this.state.invalid_confirm_password_error === true ? true : false}
                                                                helperText={this.state.confirm_password_error === true ? "Please Enter Confirm Password" : this.state.invalid_confirm_password_error === true ? "Please enter same password" : null}
                                                                value={this.state.confirm_password || ""}
                                                                onChange={(event) => this.setState({ confirm_password: event.target.value, confirm_password_error: false, invalid_confirm_password_error: false })}
                                                                margin="normal"
                                                                InputProps={{ classes: { input: classes.inputStyle } }}
                                                                InputLabelProps={{
                                                                    shrink: true,
                                                                    FormLabelClasses: {
                                                                        root: classes.labelRoot
                                                                    }
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <input
                                                                accept="image/*"
                                                                className={classes.input}
                                                                id="contained-button-file"
                                                                type="file"
                                                                onChange={this.coachImage}
                                                            />
                                                            <label htmlFor="contained-button-file">
                                                                <Button variant="outlined" component="span" className={classes.gradientButton}>
                                                                    Upload coach image
                                                            <CloudUploadIcon className={classes.rightIcon} />
                                                                </Button>
                                                            </label>
                                                            <Typography>{this.state.selected_coach_image_name}</Typography>
                                                        </Grid>
                                                    </Grid>
                                                    
                                                    <div style={{ textAlign: "center" }}>
                                                        <Button
                                                            disabled={activeStep === 0}
                                                            onClick={this.handleBack}
                                                            variant="contained" color="secondary" size="small" className={classes.cancelbutton}                >
                                                            Back
                                                    </Button>
                                                        <Button variant="contained" size="small" className={classes.button} onClick={this.submitform}>
                                                            Submit
                                                    </Button>
                                                    </div>
                                                </div>
                                                :
                                                <div>
                                                    <Grid container spacing={8}>
                                                        <Grid item xs={12} style={{ marginTop: 15, }}>
                                                            <FormLabel component="legend" required style={{ fontSize: "14px", color: 'black' }} error={this.state.interested_in_stem_error === true ? true : false}>
                                                                Are you a First team interested in learning more about STEM learning exchange program ?
                                                            </FormLabel>
                                                            <RadioButtonGroup defaultValue={this.state.interested_in_stem} onChange={this.handleChangeApproval} row >
                                                                <FormControlLabel value="Yes" control={<RadioButton />} label="Yes" />
                                                                <FormControlLabel value="No" control={<RadioButton />} label="No" />
                                                            </RadioButtonGroup>
                                                            <FormHelperText error> {this.state.interested_in_stem_error === true ? "Please select any one option Yes/No" : false} </FormHelperText>
                                                        </Grid>
                                                        <Grid item xs={4} >
                                                            <TextField
                                                                label="Team name"
                                                                fullWidth
                                                                className={classes.textField}
                                                                required
                                                                error={this.state.team_name_error === true ? true : false}
                                                                helperText={this.state.team_name_error === true ? "Please Enter Team Name" : false}
                                                                value={this.state.team_name || ""}
                                                                onChange={(event) => this.setState({ team_name: event.target.value.charAt(0).toUpperCase() + event.target.value.slice(1), team_name_error: false })}
                                                                margin="normal"
                                                                InputProps={{ classes: { input: classes.inputStyle } }}
                                                                InputLabelProps={{
                                                                    shrink: true,
                                                                    FormLabelClasses: {
                                                                        root: classes.labelRoot
                                                                    }
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={4} >
                                                            <TextField
                                                                label="City"
                                                                fullWidth
                                                                className={classes.textField}
                                                                margin="normal"
                                                                value={this.state.city || ""}
                                                                onChange={(event) => this.setState({ city: event.target.value.charAt(0).toUpperCase() + event.target.value.slice(1) })}
                                                                InputProps={{ classes: { input: classes.inputStyle1 } }}
                                                                InputLabelProps={{
                                                                    shrink: true,
                                                                    FormLabelClasses: {
                                                                        root: classes.labelRoot
                                                                    }
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={4} >
                                                            <TextField
                                                                label="Team website URL"
                                                                // type="url"
                                                                fullWidth
                                                                className={classes.textField}
                                                                error={this.state.website_url_invalid_error === true ? true : false}
                                                                helperText={this.state.website_url_invalid_error === true ? "Please Enter Valid URL" : null}
                                                                value={this.state.website_url || ""}
                                                                onChange={(event) => this.setState({ website_url: event.target.value, website_url_invalid_error: false })}
                                                                margin="normal"
                                                                InputProps={{ classes: { input: classes.inputStyle } }}
                                                                InputLabelProps={{
                                                                    shrink: true,
                                                                    FormLabelClasses: {
                                                                        root: classes.labelRoot
                                                                    }
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} >
                                                            <TextField
                                                                label="Description"
                                                                fullWidth
                                                                multiline
                                                                className={classes.textField}
                                                                value={this.state.description || ""}
                                                                onChange={(event) => this.setState({ description: event.target.value })}
                                                                margin="normal"
                                                                InputProps={{ classes: { input: classes.inputStyle } }}
                                                                InputLabelProps={{
                                                                    shrink: true,
                                                                    FormLabelClasses: {
                                                                        root: classes.labelRoot
                                                                    }
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <input
                                                                accept="image/*"
                                                                className={classes.input}
                                                                id="contained-button-file"
                                                                type="file"
                                                                onChange={this.teamImage}
                                                            />
                                                            <label htmlFor="contained-button-file">
                                                                <Button variant="outlined" component="span" className={classes.gradientButton}>
                                                                    Upload team image
                                                                <CloudUploadIcon className={classes.rightIcon} />
                                                                </Button>
                                                            </label>
                                                            <Typography>{this.state.selected_team_image_name}</Typography>
                                                        </Grid>
                                                        <Grid item xs={12} >
                                                            <div style={{ textAlign: "center" }}>
                                                                <Button variant="contained" color="secondary" size="small" className={classes.cancelbutton} onClick={this.handleClose}>
                                                                    cancel
                                                                </Button>
                                                                <Button variant="contained" size="small" className={classes.button} onClick={this.handleNext}>
                                                                    Next
                                                                </Button>
                                                            </div>
                                                        </Grid>
                                                    </Grid>
                                                </div>
                                            }                                            
                                        </div>
                                    </div>
                                )}
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }
}

TeamRegistration.propTypes = {
    classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    return {
        registerError: state.SessionReducer.registerError,

    }
}

export default compose(withStyles(styles), connect(mapStateToProps))(TeamRegistration);